import useTournaments from './useTournaments'

export default function useGamesSlugsInOngoingTournaments() {
  const { tournaments } = useTournaments()

  const gamesSlugsInTournaments = tournaments?.map(({ games }) => games).flat(1) ?? []

  return gamesSlugsInTournaments
}
